import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Custom from '@/custom/router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/industry/:industry',
      name: 'industry',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Industry.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ './views/Admin/Login.vue')
    },
    {
      path: '/admin/',
      name: 'admin',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Admin/Admin.vue'),
      children: [
        {
          path: 'login',
          name: 'loginAdmin',
          redirect: {
            name: 'login'
          }
        },
        {
          path: 'form',
          name: 'form',
          component: () => import(/* webpackChunkName: "about" */ './views/Admin/Form.vue')
        }
      ]
    },
    ...Custom,
    {
      path: '*',
      redirect: 'home'
    }
  ]
})
